export var __useDefault = true; export default "<div class=\"Card-heading\">\n    <%- T_('เลือกเว็บไซต์ของประเทศ') %>\n</div>\n";